import { PlusCircle, BarChart3, Download } from "lucide-react";
import "./quickactions.css";
import { useNavigate } from "react-router-dom";

export default function QuickActions() {
  const navigate = useNavigate();

  return (
    <div className="rp-quickactions-container">
      <h4 className="rp-quickactions-title">Quick Actions</h4>

      <div className="rp-quickactions-action-list">
        <div
          className="rp-quickactions-action-item"
          onClick={() => navigate("/leads/create")}
        >
          <span className="rp-quickactions-icon rp-quickactions-green">
            <PlusCircle size={18} />
          </span>
          <p>Create Lead</p>
        </div>

        <div className="rp-quickactions-action-item">
          <span className="rp-quickactions-icon rp-quickactions-blue">
            <BarChart3 size={18} />
          </span>
          <p>Track Status</p>
        </div>

        <div className="rp-quickactions-action-item">
          <span className="rp-quickactions-icon rp-quickactions-orange">
            <Download size={18} />
          </span>
          <p>Export Data</p>
        </div>
      </div>
    </div>
  );
}
